import { dataAfterSquare } from 'dls-icons-data'
import { createIcon } from '../common'

const IconAfterSquare = /*#__PURE__*/createIcon(dataAfterSquare)
export default IconAfterSquare
